import { Box, BoxProps } from "@chakra-ui/react";
import { ReactNode } from "react";

export const FIELD_WIDTH = "47.5%";
interface InputFieldWrapperProps extends BoxProps {
  children: ReactNode;
}

const HEIGHT_FOR_ERROR = "5.3rem";
const MAX_WIDTH = "266px";

const InputFieldWrapper = ({
  children,
  ...baseProps
}: InputFieldWrapperProps) => {
  return (
    <Box height={HEIGHT_FOR_ERROR} maxWidth={MAX_WIDTH} {...baseProps}>
      {children}
    </Box>
  );
};

export default InputFieldWrapper;
